import { currencyFormatter } from 'Utils';
import { VoucherDiscountType } from 'Types';

/**
 * Returns the formatted discount value based on the discount type.
 * @param discount - The discount value.
 * @param discountType - The type of discount (default: VoucherDiscountType.Percent).
 * @returns The formatted discount value.
 */
export const getDiscountFormat = (
	discount = 0,
	discountType: VoucherDiscountType = VoucherDiscountType.Percent
) => {
	if (discountType === VoucherDiscountType.Percent) {
		return `${discount}%`;
	} else {
		return currencyFormatter(discount);
	}
};
